import React from 'react';
/**
 * Calls a function when value changes. Value change is tracked by useRef and useEffect hooks.
 *
 * @param value - value to track
 * @param onChange - callback to call when value changes
 */
export function usePropChange(value, onChange) {
    const ref = React.useRef(value);
    React.useEffect(() => {
        if (ref.current !== value) {
            ref.current = value;
            onChange(value);
        }
    }, [value, onChange]);
}
